@if(isLoader) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Procesando'"></app-loader>
  </div>
}

<div class="p-6 space-y-5" *ngIf="!isLoader">

  <!-- Back button -->
  @if(isBack) {
    <button pButton label="Regresar" icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="backButton()"></button>
  }

  <!-- Filters card -->
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="flex flex-wrap items-center justify-between gap-3">
      <div class="flex items-center gap-3">
        <p-selectbutton [options]="viewModes" [(ngModel)]="statusFilter" optionLabel="label" optionValue="value" (onChange)="selectData()" [allowEmpty]="false" />

        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" placeholder="Búsqueda rápida..." [(ngModel)]="searchText" (keyup)="searchByText($event)" class="w-64" />
        </p-iconfield>
      </div>

      <div class="flex items-center gap-3">
        @if(!isChoice && filteredTable.length > 0 && searchText.trim() !== '') {
          <span class="text-xs text-vivid-royal-400">{{ filteredTable.length }} dispositivos</span>
        }

        @if(dataResult.length > 0 && (data.UserType === 'Administrator' || data.UserType === 'Modify')) {
          <button pButton label="Asignar" icon="pi pi-check" class="p-button-sm" (click)="update()"></button>
          <button pButton label="Cancelar" icon="pi pi-times" class="p-button-sm p-button-outlined" (click)="cancel()"></button>
        }
      </div>
    </div>
  </div>

  <!-- Content: Cards/Table view (Por Tarjeta / Por Grupo) -->
  @if(!isChoice) {
    @if(filteredTable.length > 0) {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm overflow-hidden">
        <p-table [value]="filteredTable" [paginator]="filteredTable.length > 12" [rows]="12" [rowsPerPageOptions]="[12, 24, 48]"
          styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="flex"
          [globalFilterFields]="['vehicleFullNumber','nameUser','description']"
          [showCurrentPageReport]="true" [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'">
          <ng-template #header>
            <tr>
              <th class="w-[50px]"></th>
              @if(statusFilter === 'C') {
                <th pSortableColumn="description">Grupo <p-sortIcon field="description" /></th>
              } @else {
                <th pSortableColumn="vehicleFullNumber">Dispositivo <p-sortIcon field="vehicleFullNumber" /></th>
                <th pSortableColumn="nameUser">Usuario <p-sortIcon field="nameUser" /></th>
                <th pSortableColumn="description">Descripción <p-sortIcon field="description" /></th>
              }
              <th class="w-[100px] text-center">Acción</th>
            </tr>
          </ng-template>
          <ng-template #body let-item>
            <tr class="cursor-pointer hover:bg-vivid-royal-50 dark:hover:bg-vivid-royal-900" (click)="responseInfo(item)">
              <td>
                <div class="w-8 h-8 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center">
                  <i [class]="statusFilter === 'C' ? 'pi pi-objects-column text-vivid-royal-500 dark:text-vivid-royal-300 text-sm' : 'pi pi-credit-card text-vivid-royal-500 dark:text-vivid-royal-300 text-sm'"></i>
                </div>
              </td>
              @if(statusFilter === 'C') {
                <td class="font-semibold">{{ item.description }}</td>
              } @else {
                <td class="font-mono font-semibold">{{ item.vehicleFullNumber }}</td>
                <td>{{ item.nameUser }}</td>
                <td class="text-vivid-royal-400">{{ item.description }}</td>
              }
              <td class="text-center">
                <button pButton icon="pi pi-arrow-right" class="p-button-rounded p-button-text p-button-sm" pTooltip="Seleccionar" (click)="responseInfo(item); $event.stopPropagation()"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr><td [attr.colspan]="statusFilter === 'C' ? 3 : 5" class="text-center py-8 text-vivid-royal-400">No hay elementos por visualizar</td></tr>
          </ng-template>
        </p-table>
      </div>
    } @else if(filteredTable.length === 0 && searchText.trim() !== '') {
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-12 text-center">
        <i class="pi pi-search text-4xl text-vivid-royal-300 mb-3"></i>
        <p class="text-sm text-vivid-royal-400">No se encontraron resultados para "{{ searchText }}"</p>
      </div>
    }

    @if(msgError !== '') {
      <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ msgError }}</div>
    }
  }

  <!-- Content: Station table (Por Cliente) -->
  @if(isChoice) {
    <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
      <div class="flex items-center gap-2 mb-4">
        <span class="text-sm text-vivid-royal-400">{{ response.title }}</span>
        <span class="text-sm font-semibold text-vivid-royal-700 dark:text-vivid-royal-100">{{ sendResponse.title }}</span>
      </div>

      @if(data.UserType === 'Administrator' || data.UserType === 'Modify') {
        <app-custom-table-icon
          [headers]="response.headers"
          [elements]="response.items"
          [emptyTableMessage]="'No hay estaciones por visualizar'"
          [hasFilter]="true"
          [hasButton]="true"
          [actions]="tableButtons"
          [iconName]="'Square'"
          [iconNameSelect]="'SquareCheckBig'"
          [iconColumn]="'id'"
          (dataSelect)="resultData($event)">
        </app-custom-table-icon>
      } @else {
        <app-custom-table
          [headers]="response.headers"
          [elements]="response.items"
          [emptyTableMessage]="'No hay estaciones por visualizar'"
          [hasFilter]="true"
          [hasButton]="true"
          [actions]="tableButtons">
        </app-custom-table>
      }
    </div>
  }
</div>




